import React, { useCallback } from 'react';
import moment from 'jalali-moment';
import { Box, Button, Checkbox, Grid, Image, Typography } from '@iho-design-system/Loader';

import ArrowUpSVG from '../../../assets/images/icons/arrow-up.svg';
import ArrowDownSVG from '../../../assets/images/icons/arrow-down.svg';
import ChevronDownBlue from '../../../assets/images/icons/chevron-down-blue.svg';

const UnsettledReservationsTab = ({
    GetPartialBalance,
    selectedCreditPayment,
    setSelectedCreditPayment,
    insufficientStatus,
    openModal,
}) => {
    const handleSelect = useCallback(
        (obj, status) => {
            setSelectedCreditPayment(prev => ({
                ...prev,
                [obj.Id]: `${status},${obj.Price}`,
            }));
        },
        [setSelectedCreditPayment]
    );

    const toggleDetail = useCallback((index) => {
        document.querySelector(`.detail${index}`).classList.toggle('d-none');
    }, []);

    const headers = [
        'ردیف',
        'شماره رزرو',
        'مبلغ باقیمانده (تومان)',
        'تاریخ ثبت رزرو',
        'تاریخ ثبت اصلاحیه',
        '',
    ];

    const detailHeaders = ['ردیف', 'وضعیت', 'مبلغ (تومان)', 'تاریخ', 'توضیحات'];

    return (
        <Grid>
            <Grid.Wrapper>
                {insufficientStatus && (
                    <Grid.Item size="col-12 lg-8">
                        <Box
                            className="d-inline-block p-lg border-solid border-warning rounded-sm"
                            ms={{ backgroundColor: 'var(--orange-ultra-light)' }}
                        >
                            <Typography className="d-flex text-bold">توجه</Typography>
                            <Typography>
                                موجودی کیف پول شما برای مبالغ انتخاب شده کافی کافی نیست، کیف پول خود را شارژ نمایید.
                            </Typography>
                            <Typography
                                onClick={() => openModal('increaseWalletModal')}
                                className="m-xs p-xs border-solid border-primary rounded-sm pointer"
                                ms={{ backgroundColor: 'var(--white)' }}
                            >
                                شارژ کیف پول
                            </Typography>
                        </Box>
                    </Grid.Item>
                )}

                <Grid.Item size="col-12">
                    <Box ms={{ '@media(max-width:768px)': { overflowX: 'scroll' } }}>
                        <Box ms={{ minWidth: '768px' }}>
                            <Box
                                className="d-inline-block w-100 my-sm mt-0 px-xl py-lg rounded-sm"
                                ms={{ backgroundColor: 'var(--gray-light)' }}
                            >
                                {headers.map((title, idx) => (
                                    <Box key={idx} className="d-inline-block" ms={{ width: '20%' }}>
                                        <Typography>{title}</Typography>
                                    </Box>
                                ))}
                            </Box>

                            <Box
                                className="border-solid border-light rounded-sm"
                                ms={{ backgroundColor: 'var(--white)' }}
                            >
                                {GetPartialBalance.map((obj, index) => (
                                    <Box key={obj.Id}>
                                        <Box className="d-flex justify-content-between px-lg py-md border-solid-bottom border-light">
                                            <Box ms={{ width: '25%' }}>
                                                <Checkbox
                                                    onChange={(status) => handleSelect(obj, status)}
                                                    label={index + 1}
                                                />
                                            </Box>
                                            <Box ms={{ width: '25%' }}>{obj.Id}</Box>
                                            <Box ms={{ width: '25%' }}>
                                                {(obj.Price / 10).toLocaleString()}
                                            </Box>
                                            <Box ms={{ width: '30%' }}>
                                                {moment(obj.AddDate.split('T')[0], 'YYYY-MM-DD')
                                                    .locale('fa')
                                                    .format('YYYY/MM/DD')}
                                            </Box>
                                            <Box ms={{ width: '3%' }}>
                                                {obj.AmendmentDate
                                                    ? moment(
                                                          obj.AmendmentDate.split('T')[0],
                                                          'YYYY-MM-DD'
                                                      )
                                                          .locale('fa')
                                                          .format('YYYY/MM/DD')
                                                    : ''}
                                            </Box>
                                            <Box
                                                className="d-flex justify-content-end"
                                                ms={{ width: '20%' }}
                                            >
                                                <Image
                                                    onClick={() => toggleDetail(index)}
                                                    className="pointer"
                                                    src={ChevronDownBlue}
                                                    ms={{ width: '8px', height: '8px' }}
                                                />
                                            </Box>
                                        </Box>

                                        <Box
                                            className={`detail${index} d-none px-xxl`}
                                            ms={{ backgroundColor: 'var(--gray-ultra-light)' }}
                                        >
                                            <Box className="py-md" ms={{ fontWeight: 'bold' }}>
                                                {detailHeaders.map((title, idx) => (
                                                    <Box
                                                        key={idx}
                                                        className="d-inline-block"
                                                        ms={{ width: idx === 4 ? '40%' : '15%' }}
                                                    >
                                                        <Typography>{title}</Typography>
                                                    </Box>
                                                ))}
                                            </Box>

                                            {obj.Detail.map((childObj, idx) => {
                                                const isDeposit = childObj.Price > 0;
                                                const amount = isDeposit
                                                    ? childObj.Price / 10
                                                    : (childObj.Price * -1) / 10;

                                                return (
                                                    <Box
                                                        key={idx}
                                                        className="py-md border-solid-top border-light"
                                                    >
                                                        <Box ms={{ width: '15%' }} className="d-inline-block">
                                                            {idx + 1}
                                                        </Box>
                                                        <Box ms={{ width: '15%' }} className="d-inline-block">
                                                            <Image
                                                                src={isDeposit ? ArrowDownSVG : ArrowUpSVG}
                                                                ms={{
                                                                    width: '16px',
                                                                    height: '16px',
                                                                    display: 'inline',
                                                                }}
                                                            />
                                                            <Typography
                                                                ms={{
                                                                    color: isDeposit
                                                                        ? 'var(--green-medium)'
                                                                        : 'var(--red-medium)',
                                                                    display: 'inline',
                                                                    marginLeft: '4px',
                                                                }}
                                                            >
                                                                {isDeposit ? 'واریز' : 'برداشت'}
                                                            </Typography>
                                                        </Box>
                                                        <Box ms={{ width: '15%' }} className="d-inline-block">
                                                            {amount.toLocaleString()}
                                                        </Box>
                                                        <Box ms={{ width: '15%' }} className="d-inline-block">
                                                            {moment(
                                                                childObj.AddDate.split('T')[0],
                                                                'YYYY-MM-DD'
                                                            )
                                                                .locale('fa')
                                                                .format('YYYY/MM/DD')}
                                                        </Box>
                                                        <Box ms={{ width: '40%' }} className="d-inline-block">
                                                            {childObj.Description}
                                                        </Box>
                                                    </Box>
                                                );
                                            })}
                                        </Box>
                                    </Box>
                                ))}

                                <Box
                                    className="d-flex px-sm rounded-sm rounded-top-right-0 rounded-top-left-0"
                                    ms={{
                                        height: '56px',
                                        backgroundColor: 'var(--gray-ultra-light)',
                                    }}
                                >
                                    <Box
                                        className="d-flex justify-content-center align-item-center"
                                        ms={{ gap: '16px' }}
                                    >
                                        <Button
                                            color="primary"
                                            onClick={() =>
                                                openModal('confirmCreditSettlementModal')
                                            }
                                        >
                                            پرداخت
                                        </Button>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Grid.Item>
            </Grid.Wrapper>
        </Grid>
    );
};

export default UnsettledReservationsTab;
